import Dashboard from './components/Dashboard.vue'
import Login from './components/Auth/Login.vue'
import Logout from './components/Auth/Logout.vue'
import ResetPassword from './components/Auth/ResetPassword'
import Account from '@rhitics/rhitics/components/Auth/Account/index.vue'
import AccountBasic from '@rhitics/rhitics/components/Auth/Account/Basic.vue'
import AccountPreference from '@rhitics/rhitics/components/Auth/Account/Preference.vue'
import AccessDenied from './components/errors/AccessDenied'
import Register from './components/Auth/Register'
import { RouteConfig } from 'vue-router'

export default [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      authorize: false
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
    meta: {
      authorize: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      authorize: false
    }
  },
  {
    path: '/reset_password',
    name: 'reset_password',
    component: ResetPassword,
    meta: {
      authorize: false
    }
  },
  {
    path: '/access_denied',
    name: 'AccessDenied',
    component: AccessDenied,
    meta: {
      authorize: false
    }
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    redirect: { name: 'accountBasic' },
    children: [
      {
        path: '/account/basic',
        name: 'accountBasic',
        component: AccountBasic
      },
      {
        path: '/account/preference',
        name: 'accountPref',
        component: AccountPreference
      }
    ]
  }
] as RouteConfig[]
